export const LAYOUT_TYPE_CARD = 'card'
export const LAYOUT_TYPE_LIST = 'list'
